

















import {
    Component, Prop, Vue, Comparison, ComparisonProduct, ComponentStyle,
    ComponentStyleDefinition, VueComponent, InjectComponent
} from "@zoovu/runner-browser-api";

@Component({})
export default class ComparisonTableView extends Vue {

    @Prop()
    comparison: Comparison;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("AlternativeProductsView")
    alternativeProductsView: VueComponent;

    @InjectComponent("ShownProductsView")
    shownProductsView: VueComponent;

    shownProducts: ComparisonProduct[] = [];
    alternativeProducts: ComparisonProduct[] = [];
    shownAlternativeProducts: boolean = false;

    onAlternativeProductRemoved(product) {
        this.shownProducts.push(product);
    }

    onShownProductRemoved(product) {
        this.alternativeProducts.push(product);
    }

    onAlternativeProducts(shown) {
        this.shownAlternativeProducts = shown;
    }

    beforeMount() {
        this.shownProducts = this.comparison.products.slice();
        this.alternativeProducts = this.comparison.alternativeProducts.slice();
    }
}
